// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UOxg","clinicsSelect":"styles_clinicsSelect__2EDZp"};